import {AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import Chart from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
import {LabTestDataIndicator} from "../../models/lab-test-data-indicator.model";

Chart.register(annotationPlugin);


@Component({
    selector: 'app-result-chart',
    templateUrl: './result-chart.component.html',
    styleUrls: ['./result-chart.component.css']
})
export class
ResultChartComponent implements OnChanges, AfterViewInit {
    @Input() name: string;
    @Input() score: number;
    @Input() min: number;
    @Input() max: number;
    @Input() unit: string;
    @Input() indicator: LabTestDataIndicator;

    @ViewChild('chartCanvas') chartCanvas!: ElementRef<HTMLCanvasElement>;

    chart?: Chart;

    ngAfterViewInit() {
        this.initChart();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.chart && (changes.wynik || changes.min || changes.max)) {
            this.updateChart();
        }
    }

    private initChart() {
        if (!this.chartCanvas) return;

        const correct = this.score >= this.min && this.score <= this.max;

        this.chart = new Chart(this.chartCanvas.nativeElement, {
            type: 'line',
            data: {
                labels: [],
                datasets: []
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {display: false},
                    annotation: {
                        annotations: {
                            norma: {
                                type: 'box',
                                xMin: this.min,
                                xMax: this.max,
                                backgroundColor: 'rgba(200, 200, 200, 0.3)'
                            },
                            wynik: {
                                type: 'line',
                                xMin: this.score,
                                xMax: this.score,
                                borderColor: correct ? 'green' : 'red',
                                borderWidth: 2,
                                label: {
                                    content: 'Wynik',
                                    position: 'start',
                                    color: correct ? 'green' : 'red',
                                    backgroundColor: 'transparent',
                                    font: {weight: 'bold'}
                                }
                            },
                        }
                    }
                },
                scales: {
                    x: {
                        type: 'linear',
                        position: 'bottom',
                        ticks: {
                            display: false
                        },
                        grid: {
                            display: false
                        },
                        min: this.calculateMin() - (0.2 * this.calculateMin()),
                        max: this.calculateMax() + (0.2 * this.calculateMax())
                    },
                    y: {display: false}
                }
            }
        });
    }

    private updateChart() {
        if (!this.chart) return;

        const correctValue = this.score >= this.min && this.score <= this.max;

        const annotation = this.chart.options.plugins?.annotation?.annotations as any;
        if (annotation) {
            annotation.norma.xMin = this.min;
            annotation.norma.xMax = this.max;

            annotation.wynik.xMin = this.score;
            annotation.wynik.xMax = this.score;
            annotation.wynik.borderColor = correctValue ? 'green' : 'red';
            annotation.wynik.label.color = correctValue ? 'green' : 'red';
        }

        this.chart.options.scales!.x!.min = Math.min(this.score, this.min) - 5;
        this.chart.options.scales!.x!.max = Math.max(this.score, this.max) + 5;

        this.chart.update();
    }

    private calculateMin() {
        return Math.min(this.score, this.min);
    }

    private calculateMax() {
        return Math.max(this.score, this.max);
    }

    chartAvailable() {
        if (this.indicator.valueDescription) {
            return false;
        }

        if (this.indicator.maxValue === this.indicator.minValue) {
            return this.indicator.maxValue !== 0;
        }

        return true;
    }

    indicatorHasScore(indicator: LabTestDataIndicator) {
        return indicator.type !== 6 && indicator.type !== 7;
    }
}
